/** Device-local feedback preference. An absent key means on. */
const HAPTICS_KEY = "aegae.haptics.v1";
export function getHapticsEnabled(): boolean { return localStorage.getItem(HAPTICS_KEY) !== "off"; }
export function setHapticsEnabled(enabled: boolean): void { localStorage.setItem(HAPTICS_KEY, enabled ? "on" : "off"); }
